import React from "react";
import PropTypes from "prop-types";

import { SearchTypeToggleGroup, SearchTypeToggleButton } from "./styles";

const SearchTypeToggle = ({
    defaultValue,
    exclusive,
    onChange,
    groupLabel,
    buttons
}) => {
    return (
        <SearchTypeToggleGroup
            value={defaultValue}
            exclusive={exclusive}
            onChange={onChange}
            aria-label={groupLabel}
        >
            {buttons.map(button => {
                return (
                    <SearchTypeToggleButton
                        key={button.value}
                        value={button.value}
                        aria-label={button.value}
                    >
                        {button.value}
                    </SearchTypeToggleButton>
                );
            })}
        </SearchTypeToggleGroup>
    );
};

SearchTypeToggle.defaultProps = {
    exclusive: true
};

SearchTypeToggle.propTypes = {
    defaultValue: PropTypes.string,
    exclusive: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    groupLabel: PropTypes.string.isRequired,
    buttons: PropTypes.array.isRequired
};

export { SearchTypeToggle };
